<template>
<div>
  <ScrollableDialog dialogTitle="快速登入" v-model="openDialogHandler">
    <FormBox>
      <FormBoxItem labeltxt="關鍵字">
        <FormInput v-model.trim="searchValue" placeholder="請輸入關鍵字"/>
      </FormBoxItem>
    </FormBox>
    <div class="mt-4 d-flex flex-column align-center" v-if="dataList.length > 0">
      <h2>{{ selectTitle }}</h2>
      <div class="mt-4">
        <div class="selectBox" v-for="(data, index) in dataList" :key="index" @click="handleSelect(data)">
          <div class="selectBox__item">{{ data.name }}</div>
          <div class="selectBox__item">{{ data.account }}</div>
        </div>
      </div>
    </div>
    <NoData v-if="dataList.length === 0" errorMessage="此條件查無資料"></NoData>
  </ScrollableDialog></div>
</template>

<script>
import ScrollableDialog from '@/components/dialog/ScrollableDialog.vue';
import { setToken, logout } from '@/utils/auth'; // eslint-disable-next-line
import quickLoginList from './quickLoginList.json';

export default {
  name: 'QuickLogin',
  components: {
    ScrollableDialog,
  },
  data() {
    return {
      searchValue: '',
      selectTitle: '請選擇，選擇後將自動登入或切換帳號！',
      dataList: [],
      openDialogHandler: false,
    };
  },
  mounted() {
    this.dataList = quickLoginList;
  },
  watch: {
    searchValue(val) {
      this.dataList = quickLoginList.filter((x) => x.name.includes(val) || x.account.includes(val));
    },
  },
  methods: {
    handleSelect(data) {
      const form = {
        account: data.account,
        password: data.password,
      };

      $api.user.Login(form).then((res) => {
        const { token } = res;

        if (token !== null) {
          logout();
          setToken(token);
          this.$swal.fire({
            title: '登入或切換帳號成功!',
            icon: 'success',
            iconColor: '#FB966E',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            window.location.reload();
          });
        }
        // this.$router.push('/');
      }).catch(() => {
      });
    },
  },
};

</script>

<style lang="scss" scoped>

</style>
